/**
 * W5 — Workbench command palette permission context (JWT SSOT)
 */

import { useMemo } from 'react';
import type { PathPlane } from '@shared/tenant-host/pathPlanes';
import { ROLES, normalizeUserRole, type UserRole } from '@shared/types/roles';
import { getCurrentUser } from '../../utils/jwtUtils';

export interface WorkbenchPermissionContext {
  role: UserRole;
  plane: PathPlane;
  permissionKeys: string[];
}

export function useWorkbenchPermissionContext(
  plane: PathPlane = 'business'
): WorkbenchPermissionContext {
  const currentUser = useMemo(() => getCurrentUser(), []);

  return useMemo(() => {
    const role = normalizeUserRole(currentUser?.role, ROLES.EXTERNAL);
    const permissionKeys =
      currentUser?.permissions && Array.isArray(currentUser.permissions)
        ? currentUser.permissions
        : [];

    return { role, plane, permissionKeys };
  }, [currentUser, plane]);
}
